// พจนานุกรมแปลทั้งเว็บ (ส่วนที่ 1) — "ไทย": [English, ລາວ, 中文, မြန်မာ]
/* eslint-disable */
export default {
"คน":["people","ຄົນ","人","ဦး"],
"น.":["h","ໂມງ","时","နာရီ"],
"งวด":["Draw","ງວດ","期","အကြိမ်"],
"ทอง":["Gold","ຄຳ","黄金","ရွှေ"],
"บาท":["THB","ບາດ","泰铢","ဘတ်"],
"ปิด":["Close","ປິດ","关闭","ပိတ်"],
"ฝาก":["Deposit","ຝາກ","存款","ငွေသွင်း"],
"วัน":["days","ມື້","天","ရက်"],
"หวย":["Lottery","ຫວຍ","彩票","ထီ"],
"อีก":["more","ອີກ","还差","ထပ်"],
"ไม่":["No","ບໍ່","否","မဟုတ်"],
"ไหม":["?","ບໍ?","吗？","လား"],
"0 คน":["0 people","0 ຄົນ","0 人","0 ဦး"],
"กลับ":["Back","ກັບ","返回","နောက်သို့"],
"กีฬา":["Sports","ກິລາ","体育","အားကစား"],
"ชื่อ":["Name","ຊື່","名称","အမည်"],
"ตกลง":["OK","ຕົກລົງ","确定","အိုကေ"],
"หมุน":["Spin","ໝູນ","旋转","လှည့်"],
"เงิน":["Money","ເງິນ","金额","ငွေ"],
"เติม":["Top up","ເຕີມ","充值","ငွေဖြည့်"],
"เวลา":["Time","ເວລາ","时间","အချိန်"],
"เสีย":["Loss","ເສຍ","输","ရှုံး"],
"5 บาท":["5 THB","5 ບາດ","5 泰铢","5 ဘတ်"],
"คำตอบ":["Answer","ຄຳຕອບ","答案","အဖြေ"],
"คูปอง":["Coupon","ຄູປອງ","优惠券","ကူပွန်"],
"ค้นหา":["Search","ຄົ້ນຫາ","搜索","ရှာဖွေ"],
"จำนวน":["Amount","ຈຳນວນ","数量","ပမာဏ"],
"ตกปลา":["Fishing","ຕົກປາ","钓鱼","ငါးမျှား"],
"ถัดไป":["Next","ຖັດໄປ","下一页","ရှေ့သို့"],
"ระดับ":["Level","ລະດັບ","等级","အဆင့်"],
"สถานะ":["Status","ສະຖານະ","状态","အခြေအနေ"],
"สมัคร":["Register","ສະໝັກ","注册","စာရင်းသွင်း"],
"สล็อต":["Slots","ສລັອດ","老虎机","စလော့"],
"สล๊อต":["Slots","ສລັອດ","老虎机","စလော့"],
"อีเมล":["Email","ອີເມວ","电子邮件","အီးမေးလ်"],
"โบนัส":["Bonus","ໂບນັດ","奖金","ဘောနပ်စ်"],
"*โบนัส":["*Bonus","*ໂບນັດ","*奖金","*ဘောနပ်စ်"],
"คัดลอก":["Copy","ສຳເນົາ","复制","ကူးယူ"],
"คาสิโน":["Casino","ຄາສິໂນ","娱乐场","ကာစီနို"],
"ค่าคอม":["Commission","ຄ່າຄອມ","佣金","ကော်မရှင်"],
"ติดต่อ":["Contact","ຕິດຕໍ່","联系","ဆက်သွယ်ရန်"],
"ธนาคาร":["Bank","ທະນາຄານ","银行","ဘဏ်"],
"บทความ":["Articles","ບົດຄວາມ","文章","ဆောင်းပါး"],
"ปฏิเสธ":["Rejected","ປະຕິເສດ","已拒绝","ငြင်းပယ်"],
"ประกาศ":["Announcement","ປະກາດ","公告","ကြေညာချက်"],
"ประเภท":["Type","ປະເພດ","类型","အမျိုးအစား"],
"ภาพรวม":["Overview","ພາບລວມ","概览","ခြုံငုံသုံးသပ်ချက်"],
"ภารกิจ":["Missions","ພາລະກິດ","任务","မစ်ရှင်"],
"ยกเลิก":["Cancel","ຍົກເລີກ","取消","ပယ်ဖျက်"],
"ยอดถอน":["Withdrawals","ຍອດຖອນ","提款额","ငွေထုတ်ပမာဏ"],
"ยอดฝาก":["Deposits","ຍອດຝາກ","存款额","ငွေသွင်းပမာဏ"],
"ยอดแทง":["Bet amount","ຍອດແທງ","投注额","လောင်းကြေး"],
"ยอมรับ":["Accept","ຍອມຮັບ","接受","လက်ခံ"],
"ยิงปลา":["Fish Shooting","ຍິງປາ","捕鱼","ငါးပစ်"],
"ยืนยัน":["Confirm","ຢືນຢັນ","确认","အတည်ပြု"],
"รอจ่าย":["Pending payout","ລໍຖ້າຈ່າຍ","待支付","ပေးချေရန်စောင့်ဆိုင်း"],
"รายงาน":["Report","ລາຍງານ","报告","အစီရင်ခံစာ"],
"รายวัน":["Daily","ລາຍວັນ","每日","နေ့စဉ်"],
"รายได้":["Income","ລາຍໄດ້","收入","ဝင်ငွေ"],
"ลูกสาย":["Downline","ລູກສາຍ","下线","အောက်လိုင်း"],
"วันที่":["Date","ວັນທີ","日期","ရက်စွဲ"],
"วันนี้":["Today","ມື້ນີ້","今天","ယနေ့"],
"วินาที":["seconds","ວິນາທີ","秒","စက္ကန့်"],
"สมาชิก":["Members","ສະມາຊິກ","会员","အဖွဲ့ဝင်"],
"สำเร็จ":["Success","ສຳເລັດ","成功","အောင်မြင်"],
"สูงสุด":["Max","ສູງສຸດ","最高","အများဆုံး"],
"เทิร์น":["Turnover","ເທີນ","流水","လည်ပတ်ငွေ"],
"กิจกรรม":["Activities","ກິດຈະກຳ","活动","လှုပ်ရှားမှု"],
"คำขอถอน":["Withdrawal request","ຄຳຂໍຖອນ","提款申请","ငွေထုတ်တောင်းဆိုမှု"],
"ช่องทาง":["Channel","ຊ່ອງທາງ","渠道","လမ်းကြောင်း"],
"ตั้งแต่":["From","ຕັ້ງແຕ່","从","မှ"],
"ถอนเงิน":["Withdraw","ຖອນເງິນ","提款","ငွေထုတ်"],
"ถัดไป ›":["Next ›","ຖັດໄປ ›","下一页 ›","ရှေ့သို့ ›"],
"ทั้งหมด":["All","ທັງໝົດ","全部","အားလုံး"],
"ประวัติ":["History","ປະຫວັດ","记录","မှတ်တမ်း"],
"ฝากเงิน":["Deposit","ຝາກເງິນ","存款","ငွေသွင်း"],
"พบปัญหา":["Report a problem","ພົບບັນຫາ","遇到问题","ပြဿနာရှိသည်"],
"ยอดนิยม":["Popular","ຍອດນິຍົມ","热门","လူကြိုက်များ"],
"ยอดเสีย":["Losses","ຍອດເສຍ","输额","ရှုံးငွေ"],
"รอบจ่าย":["Payout cycle","ຮອບຈ່າຍ","支付周期","ပေးချေမှုအကြိမ်"],
"ล้างค่า":["Reset","ລ້າງຄ່າ","重置","ပြန်စ"],
"อนุมัติ":["Approved","ອະນຸມັດ","已批准","အတည်ပြုပြီး"],
"อีเมล *":["Email *","ອີເມວ *","电子邮件 *","အီးမေးလ် *"],
"เปิดไพ่":["Card Flip","ເປີດໄພ່","翻牌","ကတ်လှန်"],
"เล่นเกม":["Play","ຫຼິ້ນເກມ","玩游戏","ဂိမ်းကစား"],
"แจ้งถอน":["Withdraw","ແຈ້ງຖອນ","申请提款","ငွေထုတ်"],
"โปรไฟล์":["Profile","ໂປຣໄຟລ໌","个人资料","ပရိုဖိုင်"],
"• โบนัส":["• Bonus","• ໂບນັດ","• 奖金","• ဘောနပ်စ်"],
"% ลูกสาย":["% downline","% ລູກສາຍ","% 下线","% အောက်လိုင်း"],
"ก่อนหน้า":["Previous","ກ່ອນໜ້າ","上一页","နောက်သို့"],
"จ่ายแล้ว":["Paid","ຈ່າຍແລ້ວ","已支付","ပေးပြီး"],
"ดูรายงาน":["View report","ເບິ່ງລາຍງານ","查看报告","အစီရင်ခံစာကြည့်"],
"ติดปัญหา":["Need help","ຕິດບັນຫາ","遇到问题","အကူအညီလို"],
"ทุกเลเวล":["All levels","ທຸກເລເວວ","所有等级","အဆင့်အားလုံး"],
"พันธมิตร":["Affiliate","ພັນທະມິດ","合作伙伴","မိတ်ဖက်"],
"ย้อนกลับ":["Back","ຍ້ອນກັບ","返回","နောက်သို့"],
"รหัสผ่าน":["Password","ລະຫັດຜ່ານ","密码","စကားဝှက်"],
"รายเดือน":["Monthly","ລາຍເດືອນ","每月","လစဉ်"],
"สถานะโปร":["Promo status","ສະຖານະໂປຣ","优惠状态","ပရိုမိုးရှင်းအခြေအနေ"],
"ส่วนต่าง":["Difference","ສ່ວນຕ່າງ","差额","ကွာခြားချက်"],
"ส่วนแบ่ง":["Share","ສ່ວນແບ່ງ","分成","ဝေစု"],
"หน้าเเรก":["Home","ໜ້າຫຼັກ","首页","ပင်မစာမျက်နှာ"],
"หน้าแรก":["Home","ໜ້າຫຼັກ","首页","ပင်မစာမျက်နှာ"],
"หมายเหตุ":["Note","ໝາຍເຫດ","备注","မှတ်ချက်"],
"เกมส์ฮิต":["Hot Games","ເກມຮິດ","热门游戏","ရေပန်းစားဂိမ်း"],
"เข้าเล่น":["Play now","ເຂົ້າຫຼິ້ນ","进入游戏","ကစားမည်"],
"เริ่มต้น":["Start","ເລີ່ມຕົ້ນ","开始","စတင်"],
"เลขบัญชี":["Account number","ເລກບັນຊີ","账号","အကောင့်နံပါတ်"],
"แพลทินัม":["Platinum","ແພລທິນັມ","白金","ပလက်တီနမ်"],
"ไม่กำหนด":["Not set","ບໍ່ກຳນົດ","不限","မသတ်မှတ်"],
"ไม่จำกัด":["Unlimited","ບໍ່ຈຳກັດ","无限制","အကန့်အသတ်မရှိ"],
"✓ สำเร็จ":["✓ Success","✓ ສຳເລັດ","✓ 成功","✓ အောင်မြင်"],
"ค่ายเกมส์":["Providers","ຄ່າຍເກມ","游戏厂商","ဂိမ်းထုတ်လုပ်သူ"],
"ค่ายเกม":["Providers","ຄ່າຍເກມ","游戏厂商","ဂိမ်းထုတ်လုပ်သူ"],
"จัดอันดับ":["Ranking","ຈັດອັນດັບ","排行榜","အဆင့်သတ်မှတ်ချက်"],
"จำนวนเงิน":["Amount","ຈຳນວນເງິນ","金额","ငွေပမာဏ"],
"ชื่อบัญชี":["Account name","ຊື່ບັນຊີ","账户名","အကောင့်အမည်"],
"ถอนรายได้":["Withdraw income","ຖອນລາຍໄດ້","提取收入","ဝင်ငွေထုတ်"],
"ถึงวันที่":["To date","ຮອດວັນທີ","至","ရက်စွဲအထိ"],
"ทรูมันนี่":["TrueMoney","ທຣູມັນນີ່","TrueMoney","TrueMoney"],
"ทุกประเภท":["All types","ທຸກປະເພດ","所有类型","အမျိုးအစားအားလုံး"],
"บาทขึ้นไป":["THB or more","ບາດຂຶ້ນໄປ","泰铢以上","ဘတ်နှင့်အထက်"],
"ผลิตภัณฑ์":["Product","ຜະລິດຕະພັນ","产品","ထုတ်ကုန်"],
"ผ่านเกณฑ์":["Qualified","ຜ່ານເກນ","达标","အရည်အချင်းပြည့်"],
"ยกเลิกโปร":["Cancel promo","ຍົກເລີກໂປຣ","取消优惠","ပရိုမိုးရှင်းပယ်ဖျက်"],
"รหัสแนะนำ":["Referral code","ລະຫັດແນະນຳ","推荐码","ရည်ညွှန်းကုဒ်"],
"รออนุมัติ":["Pending approval","ລໍຖ້າອະນຸມັດ","待审核","အတည်ပြုရန်စောင့်ဆိုင်း"],
"รับรางวัล":["Claim reward","ຮັບລາງວັນ","领取奖励","ဆုရယူ"],
"ลงทะเบียน":["Register","ລົງທະບຽນ","注册","စာရင်းသွင်း"],
"สนใจสมัคร":["Interested? Sign up","ສົນໃຈສະໝັກ","有意注册","စာရင်းသွင်းလိုပါသလား"],
"หมุนกงล้อ":["Spin the wheel","ໝູນກົງລໍ້","转动轮盘","ဘီးလှည့်"],
"เครือข่าย":["Network","ເຄືອຂ່າຍ","网络","ကွန်ရက်"],
"แลกรางวัล":["Redeem","ແລກລາງວັນ","兑换奖品","ဆုလဲလှယ်"],
"โปรโมชั่น":["Promotions","ໂປຣໂມຊັ່ນ","优惠活动","ပရိုမိုးရှင်း"],
"โยกเครดิต":["Transfer","ໂອນເຄຣດິດ","转移额度","ခရက်ဒစ်လွှဲ"],
"ไม่สำเร็จ":["Failed","ບໍ່ສຳເລັດ","失败","မအောင်မြင်"],
"🎁 เติมอีก":["🎁 Top up","🎁 ເຕີມອີກ","🎁 再充值","🎁 ထပ်ဖြည့်"],
"กงล้อพารวย":["Lucky Wheel","ກົງລໍ້ພາລວຍ","幸运轮盘","ကံကောင်းဘီး"],
"คืนยอดเสีย":["Cashback","ຄືນຍອດເສຍ","返水","ရှုံးငွေပြန်အမ်း"],
"จ่ายค่าคอม":["Commission paid","ຈ່າຍຄ່າຄອມ","支付佣金","ကော်မရှင်ပေးချေ"],
"ชื่อผู้ใช้":["Username","ຊື່ຜູ້ໃຊ້","用户名","အသုံးပြုသူအမည်"],
"บาท สูงสุด":["THB, max","ບາດ ສູງສຸດ","泰铢，最高","ဘတ်၊ အများဆုံး"],
"ปิดยอดเก่า":["Close old balance","ປິດຍອດເກົ່າ","结清旧额","ယခင်လက်ကျန်ပိတ်"],
"ยอดเสียสาย":["Downline losses","ຍອດເສຍສາຍ","下线输额","အောက်လိုင်းရှုံးငွေ"],
"ยังไม่ผ่าน":["Not qualified","ຍັງບໍ່ຜ່ານ","未达标","မပြည့်မီသေး"],
"รวมทั้งหมด":["Total","ລວມທັງໝົດ","合计","စုစုပေါင်း"],
"รหัสผ่าน *":["Password *","ລະຫັດຜ່ານ *","密码 *","စကားဝှက် *"],
"รหัสแนะนำ:":["Referral code:","ລະຫັດແນະນຳ:","推荐码：","ရည်ညွှန်းကုဒ်:"],
"ระดับที่ 1":["Level 1","ລະດັບທີ 1","第 1 级","အဆင့် 1"],
"ระดับที่ 2":["Level 2","ລະດັບທີ 2","第 2 级","အဆင့် 2"],
"ระดับที่ 3":["Level 3","ລະດັບທີ 3","第 3 级","အဆင့် 3"],
"ระดับที่ 4":["Level 4","ລະດັບທີ 4","第 4 级","အဆင့် 4"],
"ระดับที่ 5":["Level 5","ລະດັບທີ 5","第 5 级","အဆင့် 5"],
"รายละเอียด":["Details","ລາຍລະອຽດ","详情","အသေးစိတ်"],
"รายสัปดาห์":["Weekly","ລາຍອາທິດ","每周","အပတ်စဉ်"],
"รายอาทิตย์":["Weekly","ລາຍອາທິດ","每周","အပတ်စဉ်"],
"ลำดับที่ 1":["Rank 1","ອັນດັບ 1","第 1 名","အဆင့် 1"],
"ลำดับที่ 2":["Rank 2","ອັນດັບ 2","第 2 名","အဆင့် 2"],
"ลำดับที่ 3":["Rank 3","ອັນດັບ 3","第 3 名","အဆင့် 3"],
"ลำดับที่ 4":["Rank 4","ອັນດັບ 4","第 4 名","အဆင့် 4"],
"ลำดับที่ 5":["Rank 5","ອັນດັບ 5","第 5 名","အဆင့် 5"],
"ลิงก์แนะนำ":["Referral link","ລິ້ງແນະນຳ","推荐链接","ရည်ညွှန်းလင့်ခ်"],
"สรุปรายได้":["Income summary","ສະຫຼຸບລາຍໄດ້","收入汇总","ဝင်ငွေအနှစ်ချုပ်"],
"สล็อต-slot":["Slots","ສລັອດ","老虎机","စလော့"],
"สูงสุด 25%":["Up to 25%","ສູງສຸດ 25%","最高 25%","အများဆုံး 25%"],
"สูงสุด 35%":["Up to 35%","ສູງສຸດ 35%","最高 35%","အများဆုံး 35%"],
"สูงสุด 45%":["Up to 45%","ສູງສຸດ 45%","最高 45%","အများဆုံး 45%"],
"สูงสุด 50%":["Up to 50%","ສູງສຸດ 50%","最高 50%","အများဆုံး 50%"],
"ออกจากระบบ":["Log out","ອອກຈາກລະບົບ","退出登录","ထွက်မည်"],
};
